import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { NeqInformationPopinComponent } from "@sharedcommon/components/information-popin/information-popin.component";
import { UserService } from "@sharedcommon/services/user.service";
import { ImportSemiAutoStore, SemiautoImportMode } from "@usercommon/stores/import-semiauto.store";

@Component({
  selector: 'rawmaterials-import-semi-auto-popin',
  templateUrl: './rawmaterials-import-semi-auto-popin.component.html',
  styleUrls: ['./rawmaterials-import-semi-auto-popin.component.scss']
})
export class RawmaterialsImportSemiAutoPopinComponent implements OnInit {

  showError: boolean;
  isValidFile: boolean;

  fileErrorMessage: string;
  fileName: string;
  fileContent: string;
  file: File;
  title: string;

  constructor(
    private readonly translateService: TranslateService,
    private readonly dialogRef: MatDialogRef<RawmaterialsImportSemiAutoPopinComponent>,
    private readonly importSemiAutoStore: ImportSemiAutoStore,
    private readonly dialogService: MatDialog,
    private readonly userService: UserService
  ) {
    if (importSemiAutoStore.getImportMode() == SemiautoImportMode.CREATION) {
      this.title = 'label.user.rawmaterial.popin.import.semi-auto.creation';
    } else {
      this.title = 'label.user.rawmaterial.popin.import.semi-auto.modification';
    }
  }

  ngOnInit(): void {
    this.showError = false;
    this.isValidFile = false;
    this.fileErrorMessage = '';
    this.fileContent = null;
    this.file = null;
  }

  onFileSelection(event: any): void {
    this.showError = true;
    const file: File = event.target.files[0];
    if (!file) {
      this.isValidFile = false;
      this.fileContent = null;
      this.file = null;
    } else {
      this.file = file;
      this.fileName = file.name;

      const reader = new FileReader() ;
      reader.onload = () => {
        this.fileContent = reader.result as string ;
        this.updateValidFile() ;
      };
      reader.readAsText(file);
    }
  }

  async startImport(): Promise<void> {
    if (this.isValidFile) {
      try {
        const importState = await this.importSemiAutoStore.startImport(this.file, this.importSemiAutoStore.getImportMode());
        this.close();
        if (!importState) {
          const errorMessage: string = this.importSemiAutoStore.getRmsToProcessValue()
            .map(r => `${r.rawMaterial?.code} - ${this.translateService.instant(r.errorMsg)}`)
            .join(`
            `);
          this.displayMessage('error.user.semi-auto.all-line-in-error', {errorMessage:errorMessage});
        }
      } catch (error) {
        this.displayMessage(error.message, null);
      }
    } else {
      // display message for csv file
      this.displayMessage('msg.user.rawmaterial.import.extension-error', null);
    }
  }

  close() {
    this.dialogRef.close(false);
  }

  private updateValidFile(): void {
    const requiredError = !this.file.name;
    const extensionError: boolean = this.file.name && !this.file.name.endsWith(".csv");
    const numberImportError: boolean = (this.fileContent.split("\r\n").filter(r => r != '').length - 1) > this.userService.getEntityDto().limitImport;
    this.isValidFile = !requiredError && !extensionError && !numberImportError;
    if (this.isValidFile) {
      this.fileErrorMessage = '';
      return;
    }
    if (extensionError) {
      this.fileErrorMessage = this.translateService.instant("msg.user.rawmaterial.import.extension-error");
    } else if (requiredError) {
      this.fileErrorMessage = this.translateService.instant("msg.user.rawmaterial.import.required-file-error");
    } else if (numberImportError) {
      this.fileErrorMessage = this.translateService.instant('label.user.export.error.limit-import', {param: this.userService.getEntityDto().limitImport});
    }
  }

  private displayMessage(i18nKey: string, params: object): void {
    const dialog = this.dialogService.open(NeqInformationPopinComponent, {
      data: {
        message: i18nKey,
        params: params
      }
    });
    dialog.afterClosed().subscribe(() => {
      this.importSemiAutoStore.endImport();
    });
  }
}
